// B-735 · UNA VENTANA CON UN FORMULARIO NO SE CIERRA AL PINCHAR FUERA (23-sep-2026)
//
// El dueño: «el modal de editar tratamiento, el modal de nuevo caso de referidores, etc.: al pulsar fuera se cierra y eso
// no debe ocurrir». Un clic de más en el fondo oscuro tiraba lo que se estaba escribiendo.
//
// POR QUÉ UNA REGLA Y NO 170 CAMBIOS. En la aplicación hay más de 170 ventanas y cada una cierra «al pinchar fuera» a su
// manera (`onClick={onClose}` en el fondo, `onMouseDown` con `e.target === e.currentTarget`…). Cambiarlas una a una es
// dejarse alguna, y la siguiente que se escriba volvería a cerrarse. Aquí se decide UNA vez, antes de que el clic llegue a
// React: si lo que se pulsa ES el fondo de una ventana (una capa FIJA, a PANTALLA COMPLETA y SEMITRANSPARENTE) y esa
// ventana tiene un FORMULARIO dentro (un campo para escribir o elegir), el clic no llega.
//
// LO QUE NO TOCA: el clic DENTRO de la ventana (su destino es otro elemento), las ventanas que solo enseñan algo (un visor,
// un aviso: sin campos, se siguen cerrando al pinchar fuera), y las pantallas enteras opacas (el bloqueo de pantalla, el
// quiosco de fichar): no son un fondo semitransparente.
//
// NADIE SE QUEDA ATRAPADO. Si esa ventana no tiene a la vista cómo cerrarla («Cancelar», «Cerrar», la X con su etiqueta),
// en vez de no hacer nada se PREGUNTA («¿Cerrar esta ventana?») y, si se dice que sí, el clic se deja pasar como antes.

const CAMPOS = 'input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]), textarea, select, [contenteditable="true"], [contenteditable=""]'
const RE_CERRAR = /^(cancelar|cerrar|volver|salir|descartar|×|✕|✖|x)$/i
const RE_ETIQUETA_CERRAR = /^(cerrar|cancelar|volver|salir)/i

// La transparencia del fondo: 'rgba(0, 0, 0, 0.5)' → 0.5; un color opaco → 1; 'transparent' → 0.
function alfa(color) {
  const c = String(color || '').trim().toLowerCase()
  if (!c || c === 'transparent') return 0
  const m = /^rgba\(\s*[\d.]+\s*,\s*[\d.]+\s*,\s*[\d.]+\s*,\s*([\d.]+)\s*\)$/.exec(c)
  return m ? Number(m[1]) : 1
}

// ¿Es `el` el FONDO de una ventana que tiene un formulario?
export function esFondoConFormulario(el, win) {
  if (!el || el.nodeType !== 1 || !win || typeof win.getComputedStyle !== 'function') return false
  const cs = win.getComputedStyle(el)
  if (!cs || cs.position !== 'fixed') return false
  const a = alfa(cs.backgroundColor)
  if (!(a > 0.04 && a < 0.96)) return false
  const r = el.getBoundingClientRect ? el.getBoundingClientRect() : null
  if (!r || r.left > 2 || r.top > 2 || r.right < (win.innerWidth || 0) - 2 || r.bottom < (win.innerHeight || 0) - 2) return false
  return !!(el.querySelector && el.querySelector(CAMPOS))
}

// ¿Se ve dentro cómo cerrarla? Un botón que se llame Cancelar/Cerrar/Volver o una X con su etiqueta.
export function tieneComoCerrar(el) {
  const botones = el && el.querySelectorAll ? el.querySelectorAll('button, [role="button"], a') : []
  for (const b of botones) {
    const etiqueta = String((b.getAttribute && (b.getAttribute('aria-label') || b.getAttribute('title'))) || '').trim()
    if (RE_ETIQUETA_CERRAR.test(etiqueta)) return true
    if (RE_CERRAR.test(String(b.textContent || '').replace(/\s+/g, ' ').trim())) return true
  }
  return false
}

// Se instala UNA vez (context/DialogosContext.jsx, en el proveedor de diálogos) y devuelve cómo quitarla.
// `preguntar()` → Promise<boolean>: la pregunta para la ventana que no tiene cómo cerrarse.
export function instalarFondoDeModal(win, { preguntar } = {}) {
  if (!win || typeof win.addEventListener !== 'function') return () => {}
  let dejarPasar = null
  const alPulsar = (e) => {
    const el = e && e.target
    if (dejarPasar && el === dejarPasar) return
    if (!esFondoConFormulario(el, win)) return
    e.stopPropagation()
    if (e.type !== 'click') return
    if (tieneComoCerrar(el) || typeof preguntar !== 'function') return
    Promise.resolve(preguntar()).then((ok) => {
      if (!ok) return
      dejarPasar = el
      try {
        const Raton = win.MouseEvent
        el.dispatchEvent(new Raton('mousedown', { bubbles: true, cancelable: true }))
        el.dispatchEvent(new Raton('click', { bubbles: true, cancelable: true }))
      } finally { dejarPasar = null }
    }).catch(() => {})
  }
  win.addEventListener('mousedown', alPulsar, true)
  win.addEventListener('click', alPulsar, true)
  return () => {
    win.removeEventListener('mousedown', alPulsar, true)
    win.removeEventListener('click', alPulsar, true)
  }
}
